import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hideModal, showModal } from '../../actions/modal.actions';
import DiscountsList from "./DiscountsList";

class Discounts extends Component {

	componentDidMount() {
		document.title = 'Discounts - camvio.cloud';
		this.props.changeNavBarType('default', 'Discounts');
	}

	componentWillUnmount() {
		this.props.hideModal();
	}

	render() {
		const { isShowAccessModal } = this.props;

		if (isShowAccessModal === false) {
			return null;
		}

		return (
			<div className="cmv-container cmv-container-dashboard cmv-container-client-selected">
				<DiscountsList />
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {};
};

const mapDispatchToProps = {
	showModal,
	hideModal
};

export default connect(mapStateToProps, mapDispatchToProps)(Discounts);